import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect'; // @ts-expect-error module is untyped

import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
// @ts-expect-error module is untyped
import { getAssetBusinessTypeI18nKey } from 'ecosystem-marketplace-core/utils/i18n';
import { getIsPrerenderUserAgent } from 'ecosystem-marketplace-core/utils/userAgent';
import FilterToggleGroup from 'ecosystem-marketplace-core/filters/components/filterToggleGroup';
import * as ThemeQueryField from '../../../constants/ThemeQueryField';
import AssetBusinessTypeUrls from '../../../constants/urls/AssetBusinessType'; // @ts-expect-error module is untyped

import { getUsedBusinessTypes } from '../../../selectors/themes';
import { deployed } from '../../../utils/env';
import { getFullPublicUrl } from '../../../utils/urls';
import FilterSideNav from './FilterSideNav';
const getOptionsSelector = createSelector([getUsedBusinessTypes], businessTypes => {
  const options = businessTypes.map(value => ({
    text: unescapedText(getAssetBusinessTypeI18nKey(value)),
    value
  }));
  return options.sort((a, b) => localeComparator(a.text, b.text));
});
const getNavOptionsSelector = createSelector([getOptionsSelector, () => deployed()], (options, isDeployed) => {
  return options.reduce((final, option) => {
    const {
      value: optionValue
    } = option;
    const url = AssetBusinessTypeUrls[optionValue];

    if (url) {
      final.push(Object.assign({}, option, {
        href: `${getFullPublicUrl('en', !isDeployed)}/${url}`
      }));
    }

    return final;
  }, []);
});

function BusinessTypeNav({
  value
}) {
  const options = useSelector(getNavOptionsSelector);
  const activeValue = value.length === 1 ? value[0] : null;
  return /*#__PURE__*/_jsx(FilterSideNav, {
    "aria-label": unescapedText('marketplace-assets-ui.themes.filters.businessType.title'),
    name: ThemeQueryField.BUSINESS_TYPES,
    options: options,
    value: activeValue
  });
}

export default function BusinessTypeFilter({
  disabled,
  onChange,
  scrollable = true,
  value
}) {
  const isPrerender = getIsPrerenderUserAgent();
  const options = useSelector(getOptionsSelector);
  return isPrerender ? /*#__PURE__*/_jsx(BusinessTypeNav, {
    value: value
  }) : /*#__PURE__*/_jsx(FilterToggleGroup, {
    disabled: disabled,
    multi: true,
    name: ThemeQueryField.BUSINESS_TYPES,
    onChange: onChange,
    options: options,
    scrollable: scrollable,
    value: value
  });
}